import { 
    request
} from './api';

export const getCustomerAddressList = (params, resolve) => {
    return request(`${process.env.VUE_APP_API_URL}/customer/address/search`, "get", params, resolve);
}